import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import HomeIcon from '@material-ui/icons/Home';
import ImageIcon from '@material-ui/icons/Image';
import MessageIcon from '@material-ui/icons/NotificationsNoneOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import LocalGroceryStoreOutlinedIcon from '@material-ui/icons/LocalGroceryStoreOutlined';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShareIcon from '@material-ui/icons/Share';
import GetAppIcon from '@material-ui/icons/GetApp';
import CameraAltOutlinedIcon from '@material-ui/icons/CameraAltOutlined';
//import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';
import ImportContactsOutlinedIcon from '@material-ui/icons/ImportContactsOutlined';
import AddToPhotosOutlinedIcon from '@material-ui/icons/AddToPhotosOutlined';
import CreateIcon from '@material-ui/icons/Create';
import CloseIcon from '@material-ui/icons/Close';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import RefreshIcon from '@material-ui/icons/Refresh';
import LaunchIcon from '@material-ui/icons/Launch';

import NavItem from 'shared/components/NavItem';
import Modal from 'shared/components/Modal';

import {
  showNavBar,
  hideNavBar,
  showNavBarModal,
  showNavBarHome
} from 'shared/actions/navActions';

import {
  enableSelection,
  disableSelection,
  selectAll,
  unselectAll
} from 'shared/actions/selectionActions';

import {
  downloadGallery
} from 'app/services/DownloadService'

import {
  downloadUrl
} from 'shared/services/DownloadService';

import {
  createSharePage
} from 'app/services/ShareService'

import {
  NAV_BAR_HOME,
  NAV_BAR_PRINT_STORE,
  NAV_BAR_MODAL
} from 'shared/actions/types';

const isMobile = window.innerWidth < 960;

const styles = theme => ({
  nav: {
    position: 'fixed',
    zIndex: 9998,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    padding: isMobile ? '5px' : '1rem',
    background: '#fff',
    boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.2)'
  },
  brand: {
    height: '52px',
    width: '235px',
    marginTop: '10px',
    opacity: 0.75
  },
  form: {
    position: 'relative',
    zIndex: 2,
    width: '100%',
    background: '#fff',
    padding: '2rem 1rem',
    margin: '20vh auto 0',
    boxShadow: '3px 3px 20px rgba(0, 0, 0, 0.5)',
    maxWidth: '600px',
    borderRadius: isMobile ? 0 : '3px'
  },
  formBackdrop: {
    position: 'fixed',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
  },
  closeIcon: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: '#949494',
    opacity: 0.5,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1
    }
  },
  button: {
    border: 'none',
    borderRadius: '3px',
    background: '#000',
    color: '#fff',
    fontWeight: 600,
    fontSize: '1.2rem',
    padding: '0.5rem 1rem',
    width: '100%',
    marginTop: '1rem'
  }
});

class Nav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  componentDidMount() {
    window.navComponent = this;
  }

  componentDidUpdate() {
  }

  onClickModalBack = event => {
    event.preventDefault();
    window.currentModal.close();
  }

  onClickShare = event => {
    event.preventDefault();

    const header = 'Share';
    const buttonText = 'Share';
    const buttonIcon = <ShareIcon />;
    const cancel = () => {
      this.props.unselectAll();
      this.props.disableSelection();
      this.props.showNavBar();
    }
    const callback = () => {
      const { selectionItems, gallery } = this.props;
      let momentIds = [];
      for (let id in selectionItems) {
        if (selectionItems[id]) {
          momentIds.push(parseInt(id));
        }
      }

      createSharePage(gallery.token, momentIds)
      .then(page => {
        if (navigator.share) {
          let params = {
            url: page.url,
            title: page.story_name,
            text: page.provider_name
          }

          navigator.share(params)
          .then(() => {
            cancel();
          });
        } else {
          alert(page.url);
          cancel();
        }
      });
    }

    this.props.enableSelection(header, buttonText, buttonIcon, callback, cancel);
    this.props.hideNavBar();
    this.props.selectAll();
  }

  onClickDownload = event => {
    event.preventDefault();

    const header = 'Download';
    const buttonText = 'Download';
    const buttonIcon = <GetAppIcon />;
    const cancel = () => {
      this.props.unselectAll();
      this.props.disableSelection();
      this.props.showNavBar();
    }
    const callback = () => {
      const { selectionItems, gallery } = this.props;
      let momentIds = [];
      for (let id in selectionItems) {
        if (selectionItems[id]) {
          momentIds.push(parseInt(id));
        }
      }

      if (momentIds.length === 1) {
        const moment = this.props.moments.byId[momentIds[0]];
        const ext = (moment.type && moment.type.split("/")[1]) || 'jpeg';

        downloadUrl(`image-${moment.id}.${ext}`, moment.download_url)
        .then(() => {
          cancel();
        });
      } else {
        downloadGallery(gallery.token, momentIds)
        .then(() => {
          cancel();
        });
      }
    }

    this.props.enableSelection(header, buttonText, buttonIcon, callback, cancel);
    this.props.hideNavBar();
    this.props.selectAll();
  }

  onClickPrintStore = event => {
    window.currentMomentsScreen.openPrintStore();
    event.preventDefault();
  }

  renderShare = (classes, iconStyle) => {
    const { gallery } = this.props;
    const enabled = gallery && !gallery.disable_share_photo;

    if (enabled) {
      return (
        <NavItem label="Share"
          onClick={this.onClickShare}
          iconStyle={iconStyle}>
          <ShareIcon />
        </NavItem>
      );
    }
  }

  renderWebsite = (classes, iconStyle) => {
    const { gallery } = this.props;
    const enabled = !isMobile && !!gallery.provider_website;

    if (enabled) {
      return (
        <NavItem label={gallery.provider_name}
          href={gallery.provider_website}
          iconStyle={iconStyle}>
          <LaunchIcon />
        </NavItem>
      );
    }
  }

  renderDownload = (classes, iconStyle) => {
    return (
      <NavItem label="Download"
        iconStyle={iconStyle}
        onClick={this.onClickDownload.bind(this)}>
        <GetAppIcon />
      </NavItem>
    );
  }

  renderPrintStore = (classes, iconStyle) => {
    const { gallery } = this.props;
    const enabled = gallery && !gallery.disable_print_store;

    if (enabled) {
      if (gallery.new_tab) {
        return (
          <NavItem label="Print Store"
            href={gallery.print_store_url}
            iconStyle={iconStyle}>
            <LocalGroceryStoreOutlinedIcon />
          </NavItem>
        );
      } else {
        return (
          <NavItem label="Print Store"
            onClick={this.onClickPrintStore}
            iconStyle={iconStyle}>
            <LocalGroceryStoreOutlinedIcon />
          </NavItem>
        );
      }
    }

    return null;
  }

  renderStoryShareDialog = classes => {
    return (
      <Modal disableScrollbar={true}
        disableDrag={true}
        forceOpen={true}
        isOpen={this.state.storyShareIsOpen}
        close={this.closeStoryShare.bind(this)}>
        <div className={classes.formBackdrop}></div>
        <div className={classes.form}>
          <CloseIcon className={classes.closeIcon} onClick={this.closeStoryShare.bind(this)} style={{pointerEvents: 'auto'}} />
          <p>To download or share an image, tap the image to view it and then long tap to bring up your device's share options.</p>
          <button className={classes.button} onClick={this.closeStoryShare.bind(this)} style={{pointerEvents: 'auto'}}>
            Got it
          </button>
        </div>
      </Modal>
    );
  }

  renderNavBarHome = (classes, style) => {
    style = Object.assign({}, style);

    if (!isMobile) {
      style.top = '100px';
      style.boxShadow = 'none';
    }

    const iconStyle = {
      maxWidth: '20%'
    }

    return (
      <div className={classes.nav} style={style}>
        { this.renderShare(classes, iconStyle) }
        { this.renderDownload(classes, iconStyle) }
        { this.renderPrintStore(classes, iconStyle) }
        { this.renderWebsite(classes, iconStyle) }
      </div>
    )
  }

  renderNavBarStory = (classes, style) => {
    style = Object.assign({}, style);

    const iconStyle = {
      maxWidth: '20%'
    }

    return (
      <div id="navbar" className={classes.nav} style={style}>
        { this.renderBrand(classes) }
        { this.renderBack(classes) }
        { this.renderStoryHome(classes, iconStyle) }
        { this.renderShare(classes, iconStyle) }
        { this.renderDownload(classes, iconStyle) }
        { this.renderPrintStore(classes, iconStyle) }
        { this.renderAddPhotos() }
      </div>
    )
  }

  renderNavBarPrintStore = (classes, style) => {
    style = Object.assign({}, style);
    if (isMobile) {
      style.padding = '10px 0';
      style.justifyContent = 'flex-start';
    }

    return (
      <div id="navbar" className={classes.nav} style={style}>
        { this.renderBrand(classes) }
        <NavItem label="Back" onClick={this.onClickModalBack}>
          <ArrowBackIcon />
        </NavItem>
      </div>
    )
  }

  renderNavBarModal = (classes, style) => {
    style = Object.assign({}, style);
    if (isMobile) {
      style.padding = '10px 0';
      style.justifyContent = 'flex-start';
    }

    return (
      <div id="navbar" className={classes.nav} style={style}>
        { this.renderBrand(classes) }
        <NavItem label="Back" onClick={this.onClickModalBack}>
          <ArrowBackIcon />
        </NavItem>
      </div>
    )
  }

  render() {
    const { classes, disabled } = this.props;

    if (disabled) {
      return null;
    }

    var style = isMobile ? {
      left: 0,
      right: 0,
      bottom: 0,
      //height: '53px',
      //height: '60px',
      height: '80px',
      borderTop: '1px solid #ccc',
      transition: 'bottom 0.5s'
    } : {
      flexDirection: 'column',
      justifyContent: 'start',
      textAlign: 'left',
      top: 0,
      left: 0,
      bottom: 0,
      width: '20vw',
      background: 'rgba(255, 255, 255, 0.8)',
    }

    if (this.props.nav.hidden) {
      if (isMobile) {
        style.bottom = '-80px';
      } else {
        style.zIndex = 9997;
      }
    }

    var navBar;
    switch (this.props.nav.state) {
      case NAV_BAR_HOME:
        navBar = this.renderNavBarHome(classes, style);
        break;

      case NAV_BAR_PRINT_STORE:
        navBar = this.renderNavBarPrintStore(classes, style);
        break;

      case NAV_BAR_MODAL:
        navBar = this.renderNavBarModal(classes, style);
        break;
    }

    return (
      <div>
        { navBar }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  nav: state.navReducer.nav,
  modals: state.modalReducer.modals,
  gallery: state.galleryReducer.gallery,
  moments: state.galleryReducer.moments,
  selectionItems: state.selectionReducer.selection.items
});

const NavComponent = withStyles(styles, {withTheme: true})(Nav);

export default connect(mapStateToProps, { showNavBar, hideNavBar, showNavBarModal, showNavBarHome, enableSelection, disableSelection, selectAll, unselectAll })(NavComponent);
